module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-STRAWBERRY-SUNSET.da382c2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-STRAWBERRY-SUNSET.gif
// module id = Gb63
// module chunks = 0